/* eslint-disable react-native/no-inline-styles */
/* eslint-disable curly */
/* eslint-disable react-native/no-color-literals */
/* eslint-disable react/prop-types */
import React, { useState, useRef, useEffect } from 'react';
import {
  StyleSheet,
  View,
  PanResponder,
  Animated,
  Dimensions,
  Modal,
  TouchableOpacity,
  SafeAreaView,
  FlatList,
  useWindowDimensions,
} from 'react-native';
import NetworkLogger from 'react-native-network-logger';
import { customLogErrorWarning } from './custom-log-error-warning';
import Clipboard from '@react-native-clipboard/clipboard';

import { setShowNetworkLogger } from '@/store/global';
import SociollaText from '@components/sociolla/SociollaText';
import Colors from '@global/colors';
import { useDispatch, useSelector } from 'react-redux';

const initialWindowWidth = Dimensions.get('window').width;
const initialWindowHeight = Dimensions.get('window').height;

const NetworkLoggerFloating = ({ navigation }) => {
  const dispatch = useDispatch();
  const { width: windowWidth, height: windowHeight } = useWindowDimensions();
  const showNetworkLogger = useSelector(
    (state) => state.global.showNetworkLogger,
  );

  const [isExpanded, setIsExpanded] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [activeLogger, setActiveLogger] = useState('');
  const [errorLogItems, setErrorLogItems] = useState([]);
  const [errorLogs] = useState(customLogErrorWarning());
  const [errorCount, setErrorCount] = useState(0);
  const [toast, setToast] = useState({ visible: false, message: '' });

  const pan = useRef(
    new Animated.ValueXY({
      x: initialWindowWidth - 120,
      y: initialWindowHeight - 160,
    }),
  ).current;

  useEffect(() => {
    if (showMenu || (activeLogger === 'errors' && isExpanded)) {
      setErrorLogItems([...errorLogs]);
    }
  }, [showMenu, activeLogger, isExpanded, errorLogs]);

  useEffect(() => {
    const checkErrorsInterval = setInterval(() => {
      setErrorCount(errorLogs.length);
    }, 1000);

    return () => {
      clearInterval(checkErrorsInterval);
    };
  }, [errorLogs.length]);

  useEffect(() => {
    const isAtDefaultX =
      Math.abs(pan.x._value - (initialWindowWidth - 120)) < 10;
    const isAtDefaultY =
      Math.abs(pan.y._value - (initialWindowHeight - 160)) < 10;

    if (isAtDefaultX && isAtDefaultY) {
      pan.setValue({
        x: windowWidth - 120,
        y: windowHeight - 160,
      });
    }

    if (pan.x._value > windowWidth - 105) {
      pan.x.setValue(windowWidth - 105);
    }
    if (pan.y._value > windowHeight - 60) {
      pan.y.setValue(windowHeight - 60);
    }
  }, [windowWidth, windowHeight, pan]);

  useEffect(() => {
    if (toast.visible) {
      const timer = setTimeout(() => {
        setToast({ visible: false, message: '' });
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [toast.visible]);

  const panResponder = useRef(
    PanResponder.create({
      onStartShouldSetPanResponder: () => true,
      onMoveShouldSetPanResponder: () => true,

      onPanResponderGrant: () => {
        pan.setOffset({
          x: pan.x._value,
          y: pan.y._value,
        });
        pan.setValue({ x: 0, y: 0 });
      },

      onPanResponderMove: Animated.event([null, { dx: pan.x, dy: pan.y }], {
        useNativeDriver: false,
      }),

      onPanResponderRelease: () => {
        pan.flattenOffset();

        let posX = pan.x._value;
        let posY = pan.y._value;

        if (posX < 0) posX = 0;
        if (posX > windowWidth - 105) posX = windowWidth - 105;
        if (posY < 50) posY = 50;
        if (posY > windowHeight - 60) posY = windowHeight - 60;

        Animated.spring(pan, {
          toValue: { x: posX, y: posY },
          useNativeDriver: false,
          friction: 5,
        }).start();
      },
    }),
  ).current;

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  const openLogger = (type) => {
    setActiveLogger(type);
    setIsExpanded(true);
    setShowMenu(false);
  };

  const closeLogger = () => {
    setIsExpanded(false);
    setActiveLogger('');
  };

  const clearErrorLogs = () => {
    errorLogs.length = 0;
    setErrorLogItems([]);
    setErrorCount(0);
  };

  const copyToClipboard = async (item) => {
    const logText = `[${item.timestamp}] ${item.type.toUpperCase()}: ${
      item.message
    }`;
    await Clipboard.setString(logText);
    setToast({ visible: true, message: 'Log copied to clipboard!' });
  };

  const getLogItemStyle = (type) => {
    return {
      ...styles.logItem,
      borderLeftWidth: 5,
      borderLeftColor: type === 'error' ? '#ff5252' : '#ffab40',
    };
  };

  return (
    <>
      {activeLogger === 'network' && (
        <Modal
          animationType="slide"
          transparent={true}
          visible={isExpanded}
          onRequestClose={closeLogger}>
          <SafeAreaView style={styles.modalContainer}>
            <View style={styles.modalHeader}>
              <SociollaText
                type="medium"
                style={{ fontSize: 14, color: Colors.grey1 }}>
                Nina (DEV) - Network Logger
              </SociollaText>
              <TouchableOpacity
                style={styles.closeButton}
                onPress={closeLogger}>
                <SociollaText
                  type="medium"
                  style={{ fontSize: 14, color: Colors.grey1 }}>
                  Close
                </SociollaText>
              </TouchableOpacity>
            </View>
            <NetworkLogger theme="dark" />
          </SafeAreaView>
        </Modal>
      )}

      {activeLogger === 'errors' && (
        <Modal
          animationType="slide"
          transparent={true}
          visible={isExpanded}
          onRequestClose={closeLogger}>
          <SafeAreaView style={styles.modalContainer}>
            <View style={styles.modalHeader}>
              <SociollaText
                type="medium"
                style={{ fontSize: 14, color: Colors.grey1 }}>
                Nina (DEV) - Error Logger
              </SociollaText>
              <TouchableOpacity
                style={styles.closeButton}
                onPress={closeLogger}>
                <SociollaText
                  type="medium"
                  style={{ fontSize: 14, color: Colors.grey1 }}>
                  Close
                </SociollaText>
              </TouchableOpacity>
            </View>
            <View style={styles.loggerHeader}>
              <View style={styles.errorHeaderLeft}>
                <SociollaText
                  type="medium"
                  style={{ fontSize: 14, color: Colors.grey1 }}>
                  Error/Warning Logs
                </SociollaText>
                <View style={styles.legendContainer}>
                  <View style={styles.legendItem}>
                    <View style={styles.errorLegendDot} />
                    <SociollaText
                      type="medium"
                      style={{ fontSize: 12, color: Colors.grey1 }}>
                      Error
                    </SociollaText>
                  </View>
                  <View style={styles.legendItem}>
                    <View style={styles.warningLegendDot} />
                    <SociollaText
                      type="medium"
                      style={{ fontSize: 12, color: Colors.grey1 }}>
                      Warning
                    </SociollaText>
                  </View>
                </View>
              </View>
              <TouchableOpacity
                style={styles.clearButton}
                onPress={clearErrorLogs}>
                <SociollaText
                  type="medium"
                  style={{ fontSize: 12, color: Colors.grey1 }}>
                  Clear Logs
                </SociollaText>
              </TouchableOpacity>
            </View>
            <FlatList
              data={errorLogItems}
              keyExtractor={(item) => item.id}
              style={styles.logsList}
              renderItem={({ item }) => (
                <TouchableOpacity onPress={() => copyToClipboard(item)}>
                  <View style={getLogItemStyle(item.type)}>
                    <View style={styles.logHeader}>
                      <SociollaText
                        type="medium"
                        style={{ fontSize: 12, color: Colors.grey1 }}>
                        {item.timestamp}
                      </SociollaText>
                      <SociollaText
                        type="medium"
                        style={{
                          fontSize: 10,
                          color: item.type === 'error' ? '#ff5252' : '#ffab40',
                        }}>
                        {item.type.toUpperCase()}
                      </SociollaText>
                    </View>
                    <SociollaText
                      type="medium"
                      style={{ fontSize: 12, color: Colors.grey1 }}>
                      {item.message}
                    </SociollaText>
                  </View>
                </TouchableOpacity>
              )}
              ListEmptyComponent={
                <View
                  style={{
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}>
                  <SociollaText
                    type="medium"
                    style={{ fontSize: 14, color: '#888' }}>
                    No Errors or Warnings detected yet.
                  </SociollaText>
                </View>
              }
              contentContainerStyle={
                errorLogItems.length === 0
                  ? { flex: 1, justifyContent: 'center' }
                  : null
              }
            />
            {toast.visible && (
              <Animated.View style={styles.toastContainer}>
                <SociollaText
                  type="medium"
                  style={{ fontSize: 14, color: Colors.grey1 }}>
                  {toast.message}
                </SociollaText>
              </Animated.View>
            )}
          </SafeAreaView>
        </Modal>
      )}

      <Modal
        animationType="fade"
        transparent={true}
        visible={showMenu}
        onRequestClose={() => setShowMenu(false)}>
        <TouchableOpacity
          style={styles.menuOverlay}
          activeOpacity={1}
          onPress={() => setShowMenu(false)}>
          <Animated.View
            style={[
              styles.menuContainer,
              {
                top: pan.y._value + 50,
                left: pan.x._value,
              },
            ]}>
            <TouchableOpacity
              style={styles.menuItem}
              onPress={() => openLogger('network')}>
              <SociollaText
                type="medium"
                style={{ fontSize: 14, color: Colors.grey1 }}>
                Network Logger
              </SociollaText>
            </TouchableOpacity>
            <TouchableOpacity
              style={styles.menuItem}
              onPress={() => openLogger('errors')}>
              <View style={styles.menuItemRow}>
                <SociollaText
                  type="medium"
                  style={{ fontSize: 14, color: Colors.grey1 }}>
                  Error/Warning Logger
                </SociollaText>
                {errorCount > 0 && (
                  <View style={styles.menuCountBadge}>
                    <SociollaText
                      type="medium"
                      style={{ fontSize: 14, color: Colors.grey1 }}>
                      Logger{' '}
                      {errorCount > 0 &&
                        `(${errorCount > 99 ? `99+` : errorCount})`}
                    </SociollaText>
                  </View>
                )}
              </View>
            </TouchableOpacity>
          </Animated.View>
        </TouchableOpacity>
      </Modal>

      {showNetworkLogger && (
        <View
          pointerEvents="box-none"
          style={[StyleSheet.absoluteFillObject, { zIndex: 9999999 }]}>
          <Animated.View
            style={[
              styles.floatingButtonWrapper,
              {
                transform: [{ translateX: pan.x }, { translateY: pan.y }],
              },
            ]}
            {...panResponder.panHandlers}>
            <View style={styles.floatingButtonContainer}>
              <TouchableOpacity
                style={styles.floatingButton}
                onPress={toggleMenu}
                activeOpacity={0.8}>
                <SociollaText
                  type="medium"
                  style={{ fontSize: 14, color: Colors.white }}>
                  Logger{' '}
                  {errorCount > 0 &&
                    `(${errorCount > 99 ? `99+` : errorCount})`}
                </SociollaText>
              </TouchableOpacity>

              {errorCount > 0 &&
                errorLogs.find((item) => item.type === 'error') && (
                  <View style={styles.errorIndicator} />
                )}
              {errorCount > 0 &&
                errorLogs.find((item) => item.type === 'warning') && (
                  <View style={styles.warningIndicator} />
                )}

              <View style={styles.warningIndicator}>
                <TouchableOpacity
                  style={styles.closeFloatButton}
                  onPress={() => dispatch(setShowNetworkLogger(false))}>
                  <SociollaText
                    type="medium"
                    style={{ fontSize: 15, color: Colors.white }}>
                    ✕
                  </SociollaText>
                </TouchableOpacity>
              </View>
            </View>
          </Animated.View>
        </View>
      )}

      {toast.visible && (
        <Animated.View style={styles.toastContainer}>
          <SociollaText
            type="medium"
            style={{ fontSize: 14, color: Colors.grey1 }}>
            {toast.message}
          </SociollaText>
        </Animated.View>
      )}
    </>
  );
};

const styles = StyleSheet.create({
  floatingButtonWrapper: {
    position: 'absolute',
    zIndex: 9999999,
    elevation: 99999,
  },
  floatingButtonContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  floatingButton: {
    backgroundColor: Colors.blue1,
    width: 100,
    height: 40,
    borderRadius: 8,
    justifyContent: 'center',
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.3,
    shadowRadius: 3,
    elevation: 5,
  },
  errorIndicator: {
    position: 'absolute',
    width: 10,
    height: 10,
    borderRadius: 5,
    backgroundColor: '#ff5252',
    left: 20,
    top: -3,
    borderWidth: 1,
    borderColor: '#ffffff',
  },
  warningIndicator: {
    position: 'absolute',
    width: 10,
    height: 10,
    borderRadius: 5,
    backgroundColor: '#ffab40',
    left: 10,
    top: -3,
    borderWidth: 1,
    borderColor: '#ffffff',
  },
  modalContainer: {
    flex: 1,
    backgroundColor: '#121212',
  },
  modalHeader: {
    height: 50,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 10,
    borderBottomWidth: 1,
    borderBottomColor: '#333',
    backgroundColor: 'white',
  },
  closeButton: {
    padding: 10,
  },
  menuOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.5)',
  },
  menuContainer: {
    position: 'absolute',
    width: 200,
    backgroundColor: 'white',
    borderRadius: 8,
    overflow: 'hidden',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.3,
    shadowRadius: 3,
    elevation: 5,
  },
  menuItem: {
    padding: 15,
    borderBottomWidth: 1,
    borderBottomColor: '#f0f0f0',
  },
  menuItemRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  menuCountBadge: {
    backgroundColor: '#ff5252',
    borderRadius: 10,
    paddingHorizontal: 6,
    paddingVertical: 2,
    marginLeft: 5,
  },
  errorHeaderLeft: {
    flexDirection: 'column',
  },
  legendContainer: {
    flexDirection: 'row',
    marginTop: 4,
  },
  legendItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 12,
  },
  errorLegendDot: {
    width: 8,
    height: 8,
    borderRadius: 4,
    backgroundColor: '#ff5252',
    marginRight: 4,
  },
  warningLegendDot: {
    width: 8,
    height: 8,
    borderRadius: 4,
    backgroundColor: '#ffab40',
    marginRight: 4,
  },
  clearButton: {
    backgroundColor: '#333',
    padding: 5,
    borderRadius: 4,
  },
  logsList: {
    flex: 1,
    backgroundColor: '#121212',
  },
  logItem: {
    padding: 10,
    borderBottomWidth: 1,
    borderBottomColor: '#333',
  },
  logHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 6,
  },
  toastContainer: {
    position: 'absolute',
    bottom: 60,
    left: 20,
    right: 20,
    backgroundColor: 'rgba(238, 221, 255, 1)',
    padding: 10,
    borderRadius: 90,
    zIndex: 10000,
    alignItems: 'center',
    justifyContent: 'center',
  },
  loggerHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 10,
    backgroundColor: '#1a1a1a',
    borderBottomWidth: 1,
    borderBottomColor: '#333',
  },
  closeFloatButton: {
    position: 'absolute',
    left: 80,
    top: -10,
    backgroundColor: '#ff5252',
    borderRadius: 12,
    width: 20,
    height: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export default NetworkLoggerFloating;
